/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TotoMatchday = {
    properties: {
        matchday: {
            type: 'number',
            isRequired: true,
        },
        deadline: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
    },
} as const;
